module.exports = __webpack_public_path__ + "static/img/jingcheng.21340ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-image/jingcheng.png
// module id = zcZi
// module chunks = 1